// hkpStore.js — Datenschicht für Heil- und Kostenpläne.
// LIVE: Supabase (public.hkps, RLS) · DEMO: localStorage.
// Wie beim patientStore wird die Liste in localStorage gespiegelt
// ("dida_hkps"), damit die synchrone Rechenschicht (metrics.js) sie liest.
import { supabase } from "./supabase";
import { demoFallbacks, serverActive } from "./mode";

const CACHE_KEY = "dida_hkps";

// Demo-Seed (nur DEMO-Modus; im Live-Betrieb startet die Tabelle leer)
export const INITIAL_HKPS = [
  { id:1,  patient:"Weber, Klaus",   leistung:"Krone 46 (Zirkon)",             wert:1240, status:"angenommen", behandler:"Dr. Hoffmann", erstellt:"02.05.26", vorgelegt:"05.05.26", entschieden:"12.05.26" },
  { id:2,  patient:"Schmidt, Hans",  leistung:"Brücke 45–47",                  wert:2890, status:"vorgelegt",  behandler:"Dr. Schulz",   erstellt:"28.05.26", vorgelegt:"01.06.26" },
  { id:3,  patient:"Wolf, Inge",     leistung:"Implantat 35 + Aufbau",         wert:3450, status:"eingereicht", behandler:"Dr. Schulz",  erstellt:"20.05.26", vorgelegt:"26.05.26", eingereicht:"28.05.26" },
  { id:4,  patient:"Maier, Maria",   leistung:"Inlay 36 (Keramik)",            wert:680,  status:"angenommen", behandler:"Dr. Hoffmann", erstellt:"12.05.26", vorgelegt:"14.05.26", entschieden:"19.05.26" },
  { id:5,  patient:"Braun, Max",     leistung:"UPT-Serie + Schienentherapie",  wert:540,  status:"abgelehnt",  behandler:"Dr. Schulz",   erstellt:"05.05.26", vorgelegt:"08.05.26", entschieden:"22.05.26", grund:"Kosten zu hoch — Ratenzahlung anbieten" },
  { id:6,  patient:"Richter, Eva",   leistung:"Teilprothese OK",               wert:1980, status:"genehmigt",  behandler:"Dr. Hoffmann", erstellt:"30.05.26", vorgelegt:"03.06.26", eingereicht:"04.06.26", genehmigtAm:"10.06.26" },
  { id:7,  patient:"Fischer, Anna",  leistung:"Veneers 12–22 (IGeL)",          wert:4200, status:"entwurf",    behandler:"Dr. Schulz",   erstellt:"08.06.26" },
  { id:8,  patient:"Bauer, Lena",    leistung:"KFO-Behandlungsplan Phase 2",   wert:2400, status:"angenommen", behandler:"Dr. Bergmann", erstellt:"15.04.26", vorgelegt:"18.04.26", entschieden:"25.04.26" },
  { id:9,  patient:"Koch, Sabine",   leistung:"Krone 25 + Stiftaufbau",        wert:1480, status:"abgelaufen", behandler:"Dr. Hoffmann", erstellt:"02.03.26", vorgelegt:"06.03.26" },
  { id:10, patient:"Müller, Paul",   leistung:"Vollprothese UK",               wert:2150, status:"entwurf",    behandler:"Dr. Fischer",  erstellt:"09.06.26" },
];

const fromDb = (r) => {
  const { genehmigt_am, durchgefuehrt_am, created_at, updated_at, ...rest } = r;
  return { ...rest, genehmigtAm: genehmigt_am || undefined, durchgefuehrtAm: durchgefuehrt_am || undefined };
};
const toDb = (h) => {
  const cols = ["patient","leistung","wert","status","behandler","erstellt","vorgelegt","eingereicht","entschieden","grund","nachgefasst","art","archiviert"];
  const out = Object.fromEntries(Object.entries(h).filter(([k]) => cols.includes(k)));
  if (h.genehmigtAm !== undefined) out.genehmigt_am = h.genehmigtAm;
  if (h.durchgefuehrtAm !== undefined) out.durchgefuehrt_am = h.durchgefuehrtAm;
  return out;
};

export const loadHkpsCache = () => {
  try { const s = localStorage.getItem(CACHE_KEY); if (s) return JSON.parse(s); } catch {}
  return demoFallbacks() ? INITIAL_HKPS : [];
};
const saveCache = (rows) => { try { localStorage.setItem(CACHE_KEY, JSON.stringify(rows)); } catch {} };

export async function listHkps() {
  if (!serverActive()) { const rows = loadHkpsCache(); saveCache(rows); return rows; }
  const { data, error } = await supabase.from("hkps").select("*").order("id", { ascending: false });
  if (error) throw error;
  const rows = data.map(fromDb);
  saveCache(rows);
  return rows;
}

export async function addHkp(h) {
  if (!serverActive()) {
    const rows = [{ ...h, id: Date.now() }, ...loadHkpsCache()];
    saveCache(rows);
    return rows;
  }
  const { error } = await supabase.from("hkps").insert(toDb(h));
  if (error) throw error;
  return listHkps();
}

export async function deleteHkp(id) {
  if (!serverActive()) {
    const rows = loadHkpsCache().filter(x => x.id !== id);
    saveCache(rows);
    return rows;
  }
  const { error } = await supabase.from("hkps").delete().eq("id", id);
  if (error) throw error;
  return listHkps();
}

export async function updateHkp(id, patch) {
  if (!serverActive()) {
    const rows = loadHkpsCache().map(x => x.id === id ? { ...x, ...patch } : x);
    saveCache(rows);
    return rows;
  }
  const { error } = await supabase.from("hkps").update(toDb(patch)).eq("id", id);
  if (error) throw error;
  return listHkps();
}
